<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body"
    :class="{'is-hidden-header' : targetScrollFlg}"
    @scroll="handleScroll"
  >
  <BackgroundImage />

    <!-- menu:start -->
    <PCMenu
      class="visible"
      v-if="visibleMenu"
      @closeMenu="visibleMenu = false"
    />
    <!-- menu:end -->

    <div id="wrapper">
      <!-- header:start -->
      <header id="header" class="header">
        <PCButtonHistoryBack />
      </header>
      <!-- header:end -->

      <!-- menu-bar:start -->
      <!-- open -->
      <div class="menu-bar" role="button" 
        :class="{'is-open' : !targetScrollFlg}"
        @click="visibleMenu = !visibleMenu"
      >
        <IconMenu class="icn" 
          v-if="!targetScrollFlg"
        />
        <FontawesomeIcon :icon="['far','chevron-up']" size="lg" class="icn"
          v-if="targetScrollFlg"
        />
      </div>
      <!-- close -->
      <!-- menu-bar:end -->

      <!-- content:start -->
      <div id="content"
        style="height:calc(100vh - 84px);"
      >
        <div class="contact"
          @scroll="handleScroll"
        >
          <div class="contact-head">
            <div class="breadcrumb">
              <span class="breadcrumb-link">新規契約申し込み</span> ／ <span class="breadcrumb-link">新規契約申し込み内容の確認</span> ／ <span class="breadcrumb-link current">新規契約申し込みの完了</span>
            </div>
            <h1 class="hdg02">新規契約申し込みフォーム 申し込み完了</h1>
          </div>
          <div class="contact-container">
            <div class="contact-content">
              <p class="txt mb40">本契約のお申し込みを完了しました。</p>
              <div class="contact-submit mb40">
                <div class="button contact-submit-button">
                  <router-link class="btn" to="/pc/contract">契約情報画面へ</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- content:end -->
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
import PCMenu from '@/components/pc/popup/PCMenu.vue'
import * as logicLoggedinNewApplication from '@/logic/new-application/LoggedinNewApplication'

export default defineComponent({
  components: {
    PCMenu
  },
  setup (props, context) {

    onMounted(() => {
      // 初期表示
      group1.init()
    })

    const group1 = logicLoggedinNewApplication.getGroupComplete()

    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>
#content {
  background-color: #fff;
  border-radius: 8px 8px 0 0;
  margin-bottom: 60px;
  overflow-y: auto;
}
.breadcrumb {
  color: $color-content;
  font-size: 1.4rem;
  margin-bottom: 16px;
  &-link {
    color: $color-inactive;
    &.current {
      color: $color-content;
    }
  }
}
.contact {
  width: 100%;
  overflow: auto;
  &-container {
    border-top: 1px solid $color-line;
    padding: 40px 0;
    .button .btn[type="submit"] {
      width: 230px;
      margin: 32px auto 0;
    }
  }
  &-head {
    padding: 40px;
    [class^="hdg"] {
      margin-bottom: 0;
    }
  }
  &-content {
    max-width: 1105px;
    padding: 0 40px;
    margin: 0 auto;
    &-list {
      list-style: none;
      margin-bottom: 32px;
      &-item {
        border-top: 1px solid $color-line;
        padding: 32px 0;
      }
    }
    &-table {
      width: 100%;
      border-collapse: collapse;
      .border-none {
        border: 0!important;
      }
      &.border-bottom {
        border-bottom: 1px solid $color-line;
      }
      thead {
        th {
          color: $color-sup;
          font-size: 1.6rem;
          font-weight: normal;
          padding: 16px 20px;
        }
      }
      tbody {
        th {
          vertical-align: baseline;
        }
        th,td {
          padding: 16px 20px;
          border-top: 1px solid $color-line;
        }
      }
      &-hdg {
        display: block;
        color: $color-hdg;
        font-size: 1.6rem;
        font-weight: bold;
        &.is-inactive {
          color: $color-inactive;
        }
      }
      &-txt {
        color: $color-content;
        font-size: 1.6rem;
        line-height: 2;
      }
      &-sup {
        color: $color-sup;
        font-size: 1.4rem;
      }
      &-btnarea {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        .contact-content-table-link {
          margin-left: 20px;
        }
      }
      &-btn {
        width: 160px;
        .formparts.select .select-label,
        .button .btn {
          height: 32px;
        }
      }
      &-link {
        font-size: 1.6rem;
        color: $color-link;
      }
    }
    &-info {
      display: flex;
      justify-content: space-between;
      border-top: 1px solid $color-line;
      padding: 40px 0;
      &-table {
        width: 200px;
        th,td {
          text-align: left;
          padding: 5px 0;
        }
        th {
          color: $color-hdg;
        }
        td {
          color: $color-content;
        }
      }
      &-number {
        padding-top: 4px;
        font-size: 1.4rem;
        color: $color-sup;
        text-align: right;
      }
    }
  }
  &-submit {
    display: flex;
    align-items: center;
    justify-content: center;
    &-link {
      width: 80px;
      display: flex;
      align-items: center;
      color: $color-link;
      font-size: 1.4rem;
      @include hoverOpacity;
      .icn {
        margin-right: 10px;
      }
    }
    &-button {
      width: 230px;
      .btn {
        font-size: 1.4rem;
        @include hoverOpacity;
      }
    }
  }
}
.list-inline {
  a {
    @include hoverOpacity;
  }
}
.footer {
  margin-top: 72px;
  margin-bottom: 40px;
  text-align: center;
  a {
    font-size: 1.2rem;
  }
}
.box-package{
  border: 1px solid #ddd;
  border-radius: 5px;
  & + .box-package{
    margin-top: 50px;
  }
  .tbl04-hdgarea{
    border-top: none;
  }
  .tbl04-bodyarea{
    border-bottom: none;
    margin-bottom: 0;
  }
}
</style>
